import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=4a8a3bb3&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "./activity.vue?vue&type=style&index=0&id=4a8a3bb3&prod&lang=scss&"
import style1 from "./activity.vue?vue&type=style&index=1&id=4a8a3bb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a3bb3",
  null
  
)

export default component.exports